<div class="flex min-h-screen items-center justify-center bg-slate-100 px-4 py-8 dark:bg-slate-900">
    <div class="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 shadow-sm sm:p-8 dark:border-slate-700 dark:bg-slate-800">
        <div class="mb-6 flex justify-center">
            <img src="https://files.sokrates.co.id/sokrates.png" alt="Sokrates Logo" class="logo" style="height: 3.5rem;">
        </div>

        @if (loading) {
            <div class="flex flex-col items-center gap-3 py-4 text-center">
                <app-spinner></app-spinner>
                <p class="m-0 text-slate-600 dark:text-slate-300">{{ 'maintenance.loading' | translate }}</p>
            </div>
        }

        @if (!loading) {
            <div class="text-center">
                <h3 class="m-0 text-xl font-semibold text-slate-900 dark:text-white">
                    <i class="ic ic-cog cursor-pointer" (click)="showFqdnInput = !showFqdnInput"></i>
                    &nbsp;{{ 'maintenance.title' | translate }}
                </h3>
                <p class="mb-0 mt-3 text-slate-600 dark:text-slate-300">{{ 'maintenance.desc' | translate }}</p>
            </div>

            @if (showFqdnInput) {
                <div class="mt-5">
                    <div class="relative">
                        <app-form-field
                            [(ngModel)]="fqdn"
                            name="input-domain"
                            [label]="'main.fqdn' | translate"
                            (keydown.enter)="onSearchFqdn()"
                            [error]="error ? ('main.invalid' | translate) : null"
                        ></app-form-field>
                        <button type="button"
                            class="absolute right-3 top-3.5 appearance-none border-0 bg-transparent p-0 text-slate-400 transition hover:text-[var(--tenant-accent)]"
                            aria-label="Search" (click)="onSearchFqdn()">
                            <i class="ic ic-search"></i>
                        </button>
                    </div>
                </div>
            }
        }

        <!-- Language / theme -->
        <div class="mt-6 text-center text-sm text-slate-600 dark:text-slate-300">
            <p class="mb-0 mt-0">{{ 'main.powered_by' | translate }}
                <a href="https://sokrates.id" target="_blank" class="font-bold no-underline">Sokrates</a>
            </p>

            <p class="mb-0 mt-3"><a href="https://changelog.sokrates.co.id" target="_blank" class="no-underline">v-next</a></p>

            <p class="mb-0 mt-3">
                <a [ngClass]="getLang() === 'id' ? 'text-gray-500' : 'text-[var(--tenant-accent)]'"
                    (click)="changeLang('id')" class="cursor-pointer no-underline">Bahasa Indonesia</a>
                |
                <a [ngClass]="getLang() === 'en' ? 'text-gray-500' : 'text-[var(--tenant-accent)]'"
                    (click)="changeLang('en')" class="cursor-pointer no-underline">English</a>
            </p>

            <p class="mb-0 mt-3">
                <a [ngClass]="themeService.currentTheme === 'dark' ? 'text-gray-500' : 'text-[var(--tenant-accent)]'"
                    (click)="themeService.setTheme('dark')" class="cursor-pointer no-underline">{{ 'main.dark_mode' | translate }}</a>
                |
                <a [ngClass]="themeService.currentTheme === 'light' ? 'text-gray-500' : 'text-[var(--tenant-accent)]'"
                    (click)="themeService.setTheme('light')" class="cursor-pointer no-underline">{{ 'main.light_mode' | translate }}</a>
            </p>
        </div>
    </div>
</div>
